export const MAX_ELEMENTS_UNTIL_PAGINATION = 5;
export const MAX_CIRCLES_PER_LINE = 8;
export const CIRCLE_WIDTH = 18;